import './App.scss'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './compoment/header';
import Footer from './compoment/footer';
import Home from './pages/home';
import About from './pages/about';
import Product from './pages/product';
import Solution from './pages/solution';
import PrivacyPolicy from './pages/privacyPolicy';
import ContactUs from './pages/contactUs';
import UserAgreement from './pages/userAgreement';

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/product" element={<Product />} />
        <Route path="/solution" element={<Solution />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/user-agreement" element={<UserAgreement />} />
      </Routes>
      <Footer />
    </Router>
  );
}
export default App;